import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Input from '@mui/material/Input';
import StyledCheckbox from 'components/ui_components/StyledCheckbox/StyledCheckbox';
import { makeStyles } from '@mui/styles';
import style from './Multiselect.module.scss';

const useStyles = makeStyles({
  paper: {
    maxWidth: '350px !important',
    width: '350px !important',
  },
  list: {
    maxHeight: '600px',
    maxWidth: '350px !important',
    '& li': {
      whiteSpace: 'normal',
      maxWidth: '350px',
      width: '100%',
    }
  }
});

const MultiselectComponent = (props) => {
  const { options, selectedOptions, inputId, onClick, onChange, renderValue, label, onMouseOver, onMouseLeave, disabled } = props;
  const classes = useStyles();


  return (<FormControl className={style.formControl}>
    <InputLabel htmlFor="age-simple">{label}</InputLabel>

    <Select
      autoWidth={false}
      multiple
      onMouseLeave={onMouseLeave}
      onMouseOver={onMouseOver}
      disabled={disabled}
      value={selectedOptions}
      name={inputId}
      onClick={onClick}
      onChange={onChange}
      input={<Input id="select-multiple-checkbox"/>}
      renderValue={renderValue}
      MenuProps={{
        classes: classes,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      }}
    >
      {
        options.map(option => {
          return (
            <MenuItem key={option.value} value={option.value}>
              <StyledCheckbox checked={selectedOptions.indexOf(option.value) > -1}/>
              <ListItemText
                primary={option.label}
                primaryTypographyProps={{
                  style: {
                    fontSize: '0.8571428571428571rem',
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    lineHeight: 1.5,
                  }
                }}
              />
            </MenuItem>
          )
        })
      }
    </Select>
  </FormControl>)
}


MultiselectComponent.defaultProps = {
  disabled: false,
}


export default MultiselectComponent;
